<template>
    <div >
        <div class="conf-wrapper">
            <v-confetti class="confetti-component" ref="confettiComp"></v-confetti>
        </div>
        <div class="thanks">
            <div v-if="this.ABTestVersion === 'A' ">
                <h2><strong>Bedankt voor het meespelen!</strong></h2>

                <p>Je maakt nu kans op <strong>{{ prize }}.</strong></p>

                <p>De winnaar wordt uiterlijk in week 10 door Lotto benaderd.</p>

                <h4>Voor € 2 kun jij ook miljonair zijn!</h4>

                <p>Met Lotto maak je elke zaterdag voor €2 kans op de jackpot van minimaal €2.500.000. En de Lotto Jackpot is óók nog eens de vaakst
                vallende Jackpot in Nederland. Meespelen met Lotto is spannend, leuk en heel eenvoudig.</p>

                <div class="button-wrapper">
                    <a class="button" href="https://lotto.nederlandseloterij.nl/loten-kopen/getallen-kiezen" target="_blank">Kies je getallen!</a>
                </div>
            </div>
            <div v-else>
                <h2><strong>Beste {{ firstName }},</br>Bedankt voor het meespelen!</strong></h2>

                <p>Je maakt nu kans op <strong>{{ prize }}.</strong></p>

                <p>De winnaar wordt uiterlijk in week 10 door Lotto benaderd.</p>

                <h4>Elke week kans op de jackpot én een welkomstcadeau</h4>

                <a style="display:block;" href="https://lotto.nederlandseloterij.nl/automatisch-meespelen/getallen-kiezen?utm_source=lot-actiepagina-hogerlager&utm_campaign=hogerlager&utm_medium=ibr" target="_blank"><img src="/static/img/mail/visual.jpg" /></a>

                <p>Met Lotto maak je elke zaterdag voor €2 kans op de jackpot van minimaal €2.500.000. En de Lotto Jackpot is óók nog eens de vaakst
                 vallende Jackpot in Nederland. Meespelen met Lotto is spannend, leuk en heel eenvoudig.</p>

                <p>Ga nu automatisch meespelen, mis geen enkele trekking én ontvang een welkomstcadeau! Je kan op elk moment eenvoudig opzeggen.</p>

                <div class="button-wrapper">
                    <a class="button" href="https://lotto.nederlandseloterij.nl/automatisch-meespelen/getallen-kiezen?utm_source=lot-actiepagina-hogerlager&utm_campaign=hogerlager&utm_medium=ibr" target="_blank">Speel mee!</a>
                </div>
             </div>

            <!-- <h2>Bedankt!</h2>
            <p>We hebben je gegevens opgeslagen.<br/>Je maakt nu kans op <strong>{{ prize }}!</strong></p>

            <p>De trekking vindt plaats in week&nbsp;29.<br/>Lotto neemt direct contact op met de winnaar per&nbsp;mail.</p>

            <p class="small" v-if="correctAnswers < 6">Niet tevreden met je score?<br/>Doe gerust <router-link replace to="game">nog een keer mee</router-link>.</p>

            <p v-if="this.ABTestVersion === 'A' ">I am A</p>
            <p v-else>I is B</p>

            <h3>Deel jouw highscore met je vrienden</h3>

            <div class="button-wrapper shares">
                <button class="button share facebook" @click="shareFacebook">Share</button>
                <a class="button share twitter" :href="twitterUrl" target="_blank">Tweet</a>
                <a v-if="isMobile" class="button share whatsapp" :href="whatsappUrl" target="_blank">Share</a>
            </div> -->
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .conf-wrapper{
        transform:translateY(-200px);
        position:absolute;
        width:100%;
        height:100%;
        z-index:0;
    }
</style>

<script>
    import { TimelineMax } from '@/vendor';
    import Confetti from '@/app/components/Confetti';

    export default {
        components: {
            'v-confetti': Confetti
        },

        computed: {
            ABTestVersion()
            {
                return this.$store.getters.ABTest;
            },

            isMobile()
            {
                return this.$helpers.browserCheck().isMobile;
            },

            isKnownPlayer()
            {
                return this.$store.getters.isKnownPlayer;
            },

            correctAnswers()
            {
                return this.$store.getters['getCorrectAnswers'].length;
            },

            numCorrect()
            {
                return this.$store.getters['getCorrectBalls'].length;
            },

            prize()
            {
                let prizeList = [
                    '€500',
                    '€1.000',
                    '€2.000',
                    '€3.000',
                    '€4.000',
                    '€4.500'
                ];

                return prizeList[ this.numCorrect - 1 ];
            },

            twitterUrl()
            {
                let text = 'Is de volgende bal Hoger of Lager? Speel Lotto Hoger/Lager en maak kans op €4.500! ' + window._rootData.apiUrl;
                let hashtags = [ 'Laatjelotnietliggen' ];

                let twitterLink = 'http://twitter.com/intent/tweet?text=' + encodeURIComponent( text ) + '&hashtags=' + hashtags.join( ', ' );

                return twitterLink;
            },

            whatsappUrl()
            {
                let text = 'Is de volgende bal Hoger of Lager? Speel Lotto Hoger/Lager en maak kans op €4.500! ' + window._rootData.apiUrl;
                return 'whatsapp://send?text=' + encodeURIComponent( text );
            },
            firstName()
            {
                return this.$store.getters[ 'entry/all' ].firstname;
            }
        },

        mounted()
        {
            // console.log( 'the store entry', this.$store );
            this.$refs.confettiComp.spawnConfetti( 6 * 10 );
        },

        methods: {
            shareFacebook()
            {
                window.FB.ui(
                    {
                        method: 'share',
                        href: window._rootData.apiUrl + '/share/' + this.$store.getters['getEntry'].id
                    },
                    function( response )
                    {
                        if( response && !response.error_message )
                        {
                            // console.log( 'Posting completed.' );
                            // return;
                        }
                        // console.log( 'Error while posting.' );
                    }
                );
            },

            getAnimateIn()
            {
                let tl = new TimelineMax();

                tl.staggerFrom( '.thanks > *', 0.2, { y: 20, opacity: 0 }, 0.1 );

                return tl;
            },

            getAnimateOut()
            {
                let tl = new TimelineMax();

                tl.to( this.$el, 0.3, { opacity: 0 });

                return tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Thanks.vue